import React from 'react';
export function LaserCuttingSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10" data-id="element-2241">
      <h2 className="text-2xl font-bold text-[#1967a5] mb-6" data-id="element-2242">
        Laser Cutting FAQ
      </h2>
      <ul className="space-y-3 list-disc list-inside" data-id="element-2243">
        <li data-id="element-2244">
          <a href="/WhyDoWeNeed10kWLaserCutting.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2245">
            Why Do We Need A 10kW+ Laser Cutting Machine?
          </a>
        </li>
        <li data-id="element-2246">
          <a href="/CO2vsFiberLaser.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2247">
            CO2 Laser vs. Fiber Laser - What's the difference?
          </a>
        </li>
        <li data-id="element-2248">
          <a href="/PlasmaVsFiberLaser.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2249">
            Plasma Cutter vs. Fiber Laser - What's the difference?
          </a>
        </li>
      </ul>
    </div>;
}